import React, { FC } from "react";
import { Switch, Route } from "Utils/router";
import WithLocId from "HOC/WithLocId";
import { CampusMap } from "Containers/CampusMap";
import ADACampusMap from "Containers/ADACampusMap";
import TourInitializer from "HOC/TourInitializer";
import YouVisitAnalytics from "HOC/YouVisitAnalytics";
import PageNotFound from "Components/helpers/PageNotFound";

interface Props {
  apolloData?: object;
  match?: {};
}

const Routes: FC<Props> = () => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path="/tour/map/ada/:instId/:locId?"
          render={(props) => (
            <WithLocId
              instId={props.match.params.instId}
              locId={props.match.params.locId}
            >
              <TourInitializer>
                <YouVisitAnalytics>
                  <ADACampusMap />
                </YouVisitAnalytics>
              </TourInitializer>
            </WithLocId>
          )}
        />
        <Route
          exact
          path="/tour/map/:instId/:locId?"
          render={(props) => (
            <WithLocId
              instId={props.match.params.instId}
              locId={props.match.params.locId}
            >
              <TourInitializer>
                <YouVisitAnalytics>
                  <CampusMap />
                </YouVisitAnalytics>
              </TourInitializer>
            </WithLocId>
          )}
        />
        <Route>
          <PageNotFound />
        </Route>
      </Switch>
    </div>
  );
};

export default Routes;
try {
    // @ts-ignore
    routes.displayName = "routes";
    // @ts-ignore
    routes.__docgenInfo = { "description": "", "displayName": "routes", "props": { "apolloData": { "defaultValue": null, "description": "", "name": "apolloData", "required": false, "type": { "name": "object" } }, "match": { "defaultValue": null, "description": "", "name": "match", "required": false, "type": { "name": "{}" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/routes.tsx#routes"] = { docgenInfo: routes.__docgenInfo, name: "routes", path: "src/routes/routes.tsx#routes" };
}
catch (__react_docgen_typescript_loader_error) { }